import Root from './routes/Root';

export default function App() {
  return <Root />;
}
